// Importing necessary packages
import "reflect-metadata";
import DependencyInjectionCommonsInfrastructure from "./commons/dependencyInjectionCommonsInfrastructure";
import { DependencyInjectionProductsInfrastructure } from "./products/dependencyInjectorProductsInfrastructure";
import { DependencyInjectionUtilsInfrastructure } from "./utils/dependencyInjectorUtilsInfrastructure";
import { DependencyInjectionLocationsInfrastructure } from "./locations/dependencyInjectorLocationsInfrastructure";
import { DependencyInjectorExternalInfrastructure } from "./external/dependencyInjectorExternalInfrastructure";
import DependencyInjectionRentersInfrastructure from "./renters/dependencyInjectorRentersInfrastructure";
import DependencyInjectionVideosInfrastructure from "./videos/dependencyInjectorVideosInfrastructure";
import DependencyInjectorCustomersInfrastructure from "./customers/dependencyInjectorCustomersInfrastructure";
import DependencyInjectioOrdersInfrastructure from "./orders/DependencyInjectioOrdersInfrastructure";
import DependencyInjectionBannersInfrastructure from "./banners/dependencyInjectorBannersInfrastructure";
import DependencyInjectioIpsInfrastructure from "./ips/DependencyInjectioIpsInfrastructure";
import DependencyInjectorConfigsInfrastructure from "./configurations/dependencyInjectorConfigsInfrastructure";
import { DependencyInjectionEsimInfrastructure } from "./esim/dependencyInjectorEsimInfrastructure";
import { container } from "tsyringe";
import { useStoreAplication } from "./persistence/zuntand/useStoreAplication";
/**
 * Initializes dependency injection for various modules.
 */
const dependencyInjectionInfrastructure = () => {
    // Initializing dependency injection for Commons module
    DependencyInjectionCommonsInfrastructure();
    // Initializing dependency injection for Products module
    DependencyInjectionProductsInfrastructure();
    // Initializing dependency injection for Utils module
    DependencyInjectionUtilsInfrastructure();
    // Initializing dependency injection for Locations module
    DependencyInjectionLocationsInfrastructure();
    // Initializing dependency injection for External module
    DependencyInjectorExternalInfrastructure();
    // Initializing dependency injection for Renters module
    DependencyInjectionRentersInfrastructure();
    // Initializing dependency injection for Videos module
    DependencyInjectionVideosInfrastructure();
    // Initializing dependency injection for Customers module
    DependencyInjectorCustomersInfrastructure();
    /// Initializing dependency injection for Orders module
    DependencyInjectioOrdersInfrastructure();
    // Initializing dependency injection for Banners module
    DependencyInjectionBannersInfrastructure();
    // Initializing dependency injection for Ips module
    DependencyInjectioIpsInfrastructure();
    DependencyInjectorConfigsInfrastructure();
    // Initializing dependency injection for eSIM module
    DependencyInjectionEsimInfrastructure();
    // Registering the application state store with tsyringe
    container.register("IUseStoreAplication", {
        useFactory: () => useStoreAplication(),
    });
};
// Exporting the function to initialize dependency injection infrastructure
export default dependencyInjectionInfrastructure;
